import { Tooltip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import JxButton from '../../../JxControls/JxButtons/JxButton';
import JxIconButton from '../../../JxControls/JxButtons/JxIconButton';
import JxLineEdit from '../../../JxControls/JxEdits/JxLineEdit';
import JxCopyEdit from '../../../JxControls/JxEdits/JxCopyEdit';
import { Field } from '../../../Widgets/FormBuilderWidget/UI/Utils/FormBuilderFormComponents';
import { tooltipSxElevated } from '../../../components/shared/jernyTooltipStyling';

/**
 * UmlSchemaDlgBody — velden + Save. Puur presentationeel, geen eigen state/hooks —
 * form komt van UmlSchemaDlg.state.inputs, onChange is de echte handleChange(field,value)
 * van JxFormValidationBase.
 *
 * New/Load Uml/Import zijn GEEN knoppen meer hier — die zitten nu op de Start-tab
 * (UmlSchemaStartTab.jsx) resp. Import-tab (UmlSchemaImportTab.jsx). Deze Body is
 * puur de Properties-tab-inhoud.
 *
 * Tooltips: MUI Tooltip + tooltipSxElevated (jernyTooltipStyling.js) — zie Development.Patterns
 * rk=ed2d2d36-15de-4867-8b09-552a7801b626. Bekend als tech-debt (zie Development.Patterns
 * rk=91877cd246fa4653822093502e086c45): dit hoort eigenlijk via JxTooltip te lopen, niet
 * rechtstreeks MUI — nog niet omgezet.
 * @param {{ form: object, onChange: Function, onSave: Function, isSaving: boolean }} props
 */
export default function UmlSchemaDlgBody({ form, onChange, onSave, isSaving }) {
    return (
        <div className="usd-body">
            <div className="usd-button-row" style={{ marginTop: 4, marginBottom: 8 }}>
                <Tooltip title={form.rk ? 'Update' : 'Create new note'} componentsProps={tooltipSxElevated}>
                    <span>
                        <JxButton
                            className={form.name ? 'jx-btn-save dirty' : 'jx-btn-save'}
                            label="Save"
                            onClick={onSave}
                            disabled={!form.name || isSaving}
                        />
                    </span>
                </Tooltip>
            </div>

            {form.rk && (
                <Field labelPos="left" labelWidth={70} sxc={{ mb: '8px' }} label="RowKey" tip="RowKey of this UmlSchema note.">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, width: '100%' }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <JxCopyEdit value={form.rk} label="RowKey" onChange={() => {}} disabled />
                        </div>
                        <Tooltip title="Clear RowKey (next Save creates a new note)" componentsProps={tooltipSxElevated}>
                            <span>
                                <JxIconButton icon={<ClearIcon sx={{ fontSize: 16 }} />} onClick={() => onChange('rk', '')} />
                            </span>
                        </Tooltip>
                    </div>
                </Field>
            )}

            <Field labelPos="left" labelWidth={70} sxc={{ mb: '8px' }} label="Name *" tip="Title of the UmlWorkspace note.">
                <JxLineEdit value={form.name} onChange={(v) => onChange('name', v)} placeholder="e.g. Ingestion Flow" />
            </Field>

            <Field
                labelPos="left"
                labelWidth={70}
                sxc={{ mb: '8px' }}
                label="Service"
                tip="Topic this note goes into (free text, default Jerny.UmlWorkspace)."
            >
                <JxLineEdit value={form.service} onChange={(v) => onChange('service', v)} placeholder="Jerny.UmlWorkspace" />
            </Field>

            <Field labelPos="left" labelWidth={70} sxc={{ mb: '8px' }} label="Format" tip="Diagram type, currently always class-diagram.">
                <JxLineEdit value={form.format} onChange={(v) => onChange('format', v)} placeholder="class-diagram" />
            </Field>

            <Field labelPos="left" labelWidth={70} sxc={{ mb: '8px' }} label="Remarks" tip="Free text, what this schema is for.">
                <textarea
                    className="jx-line-edit"
                    style={{
                        width: '100%',
                        minHeight: 50,
                        height: 'auto',
                        padding: '8px 10px',
                        resize: 'vertical',
                        boxSizing: 'border-box',
                    }}
                    value={form.remarks ?? ''}
                    onChange={(e) => onChange('remarks', e.target.value)}
                    placeholder="e.g. Overview of the pub/sub ingestion layer"
                />
            </Field>
        </div>
    );
}
